/* eslint-disable */
import { Box, Button, Card, CardActions, Container, Pagination, Popover, Typography, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useEffect, useRef, useState } from 'react';
import { compareTwoDates, getDateObj } from '../../../utils/date-utils';
import { useDispatch, useSelector } from 'react-redux';
import { getClaims } from '../../../redux/claims/actions';
import { useNavigate } from 'react-router-dom';
import { KeyboardArrowDown, KeyboardArrowUp, Info, ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { camelCaseString, capitalizeString } from '../../../utils/format-utils';
import { getMemberAccounts } from '../../../redux/memberAccounts/action';
import { formatDate } from '../functionUtils';
import Label from '../type/Label';

const DEFAULT_PAGE_SIZE = 5;
const DEFAULT_PAGE_NUMBER = 1;

const ANY_DATE = 'ANY-DATE';
const ALL_MEMBERS = <Label id='allMembers'/>;
const ANYDATES = <Label id='allDates'/>;
const ClaimsListSection = () => {
    const dispatch = useDispatch();
    const [filterDate, setFilterDate] = useState({
        openPopover: false,
        fromDate: '',
        toDate: '',
        selectedDateFormat: ANY_DATE,
        anchorElement: null,
        dateError: false,
        dateErrorDescription: '',
        labelName: ANYDATES
    });
    const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [memberList, setMemberList] = useState([]);
    const [filterMember, setFilterMember] = useState({
        openPopover: false,
        anchorElement: null,
        memberError: false,
        memberErrorDescription: '',
        selectedMemberHeader: '',
        labelName: ALL_MEMBERS
    });
    const [sortFilter, setSortFilter] = useState({
        openPopover: false,
        anchorElement: null,
        sortType: 'MOST-RECENT',
        labelName: 'Mostrecent',
    });

    const inputRefForToDate = useRef(null);
    const labelRefForToDate = useRef(null);
    const navigate = useNavigate();
    const claimsList = useSelector(state => state?.claims?.claims);
    const memberAccountError = useSelector(state => state?.memberAccounts.error);
    const paginationEnd = useSelector(state => state?.claims?.pagination?.lastPage);
    const totalElements = useSelector(state => state?.claims?.pagination?.totalElements);
    const memberAccounts = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails
    );
    const claimsYouOweList = useSelector(state => state?.claims?.claimsYouOwe);
    const navigateToClaim = (claimNumber, memberAccountHeader) => {
        navigate(`/claims/${claimNumber}`, { state: { memberAccountHeader } });
    };
    
    const [isMemberSelected, setIsMemberSelected] = useState(false);
    useEffect(() => {
        dispatch(getMemberAccounts(localStorage.getItem('tenantHandle')));
    }, [])

    
    useEffect(() => {
    if (memberAccounts?.self || memberAccounts?.dependents) {
        if (memberAccounts?.self) {
        setMemberList([{ ...memberAccounts.self }, ...(memberAccounts.dependents || [])]);
        } else {
        setMemberList([...(memberAccounts.dependents || [])]);
        }
    } else {
        setMemberList([]);
    }
    }, [memberAccounts]);

    useEffect(() => {
        dispatch(getClaims(localStorage.getItem('tenantHandle'), pageNumber - 1, pageSize, filterDate.fromDate, filterDate.toDate, sortFilter.sortType === 'MOST-RECENT' ? 'desc' : 'asc', filterMember.selectedMemberHeader));

    }, [pageNumber, pageSize]);

    useEffect(() => {
        if (filterDate.fromDate && filterDate.toDate) {
            if (!compareTwoDates(filterDate.fromDate, filterDate.toDate)) {
                setFilterDate({ ...filterDate, dateError: true, dateErrorDescription: <Label id='ToDateCannotBeBeforeFromDate' /> });
                inputRefForToDate.current.style.borderColor = 'red';
                labelRefForToDate.current.style.color = 'red';

            } else {
                setFilterDate({ ...filterDate, dateError: false, dateErrorDescription: '' });
                inputRefForToDate.current.style.borderColor = '#00000099';
                labelRefForToDate.current.style.color = '#000';
            }
        }
        return;
    }, [filterDate.toDate, filterDate.fromDate]);

    useEffect(() => {
        const { fromDate, toDate } = filterDate;
        const updatedMembers = memberList.map((member => {
            return {
                ...member, includeMember: false
            }
        }));
        setMemberList(updatedMembers);
        dispatch(getClaims(localStorage.getItem('tenantHandle'), pageNumber - 1,
            pageSize, fromDate, toDate, sortFilter.labelName === 'Mostrecent' ? 'desc' : 'asc', filterMember.selectedMemberHeader
        ));
    }, [sortFilter.labelName]);

    const setDatePopover = (event) => {
        setFilterDate({ ...filterDate, openPopover: true, anchorElement: event.currentTarget });
    };
    const handleCloseDatePopover = () => {
        setFilterDate({ ...filterDate, openPopover: false, anchorElement: null });
    };
    const setDateTypeFilter = (event) => {
        let value = event.target.value;
        if (value === ANY_DATE) {
            setFilterDate({ ...filterDate, selectedDateFormat: value, fromDate: '', toDate: '', dateError: false });
        }
        else {
            setFilterDate({ ...filterDate, selectedDateFormat: value });
        }
    };
    const setMemberHeader = (event)=> {
        setIsMemberSelected(true);
        setFilterMember({...filterMember, selectedMemberHeader: event.target.value });
    }
    const handleCloseMemberPopover = () => {
        setFilterMember({ ...filterMember, openPopover: false, anchorElement: null });
    };
    const setMemberFilter = (event) => {
        setFilterMember({ ...filterMember, anchorElement: event.currentTarget, openPopover: true });
    };
    const handleSortFilter = (event) => {
        setSortFilter({ ...sortFilter, labelName: sortFilter.labelName === 'Mostrecent' ? 'Oldest' : 'Mostrecent' });
    };
 
    const getMemberHeader = (member) => {
        return `${member?.groupId}-${member?.subscriberId}-${member?.subscriberSuffix}`;
    }

    const getMemberHeaderFromClaim = (claim) => {
        const member = memberList.find(
            m => m.subscriberId === claim.memberID && m.subscriberSuffix === claim.memberSuffix
        );
        if (member) {
            return `${member?.groupId}-${member?.subscriberId}-${member?.subscriberSuffix}`;
        }
        return '';
    };

    const handleFilterChanges = (event) => {
        event.preventDefault();
        const { fromDate, toDate } = filterDate;
        let dateLabelName = '';
        if (filterDate.selectedDateFormat === ANY_DATE) {
            dateLabelName = ANYDATES;
        }
        else {
            dateLabelName = formatDate(fromDate) + '-' + formatDate(toDate);
        }
        setFilterDate({ ...filterDate, openPopover: false, anchorElement: null, labelName: dateLabelName });
        if(filterMember.selectedMemberHeader){
            let selectedMember = memberList.filter((member)=> getMemberHeader(member) === filterMember.selectedMemberHeader)[0];
            setFilterMember({...filterMember, labelName: selectedMember?.firstName + ' ' + selectedMember?.lastName,      
             openPopover: false,
            anchorElement: null });
        }

        dispatch(getClaims(localStorage.getItem('tenantHandle'), pageNumber - 1,
            pageSize, fromDate, toDate, sortFilter.labelName === 'Mostrecent' ? 'desc' : 'asc', filterMember.selectedMemberHeader));
    }
    const onPageChange = (_, value) => {
        setPageNumber(value);
    };

    const handleResetDate = () => {
        setFilterDate({ ...filterDate, fromDate: '', toDate: '', openPopover: false, anchorElement: null, selectedDateFormat: ANY_DATE, dateError: false, dateErrorDescription: '', labelName: ANYDATES });
        dispatch(getClaims(localStorage.getItem('tenantHandle'), pageNumber - 1,
            pageSize, '', '', sortFilter.labelName === 'Mostrecent' ? 'desc' : 'asc', filterMember.selectedMemberHeader
        ));
    }
    const handleResetMemberFilter = () => {
        setIsMemberSelected(false);
        setFilterMember({
            openPopover: false,
            anchorElement: null,
            memberError: false,
            memberErrorDescription: '',
            labelName: ALL_MEMBERS,
            selectedMemberHeader: '',
        });
        dispatch(getClaims(localStorage.getItem('tenantHandle'), pageNumber - 1,
            pageSize, filterDate.fromDate, filterDate.toDate, sortFilter.labelName === 'Mostrecent' ? 'desc' : 'asc',
            ''
        ));
    }

    return (
        <Box className='claimsListSection'>
            {<Container className='claimsFilters'>
                <Container className='filtersLeftSection'>
                   
                    <Button className='filterBtnPopver' id='search-date-id' onClick={setDatePopover}>
                        {filterDate.labelName}  {filterDate.openPopover ? <KeyboardArrowUp color='primary' /> : <KeyboardArrowDown color='primary' />}
                    </Button>
                    <Popover
                        open={filterDate.openPopover}
                        anchorEl={filterDate.anchorElement}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handleCloseDatePopover}
                    >
                        <Card className='popOverCard' component='form' onSubmit={handleFilterChanges} >
                            <Typography variant='body1'><Label id="DateofService" /></Typography>
                            <FormControl className='popoverForm'>
                                <RadioGroup onChange={setDateTypeFilter} value={filterDate.selectedDateFormat}>
                                    <FormControlLabel value={'ANY-DATE'} control={<Radio />} label={<Typography color={filterDate.selectedDateFormat === 'ANY-DATE' ? 'primary' : 'black'} variant='body1'><Label id='allDates'/></Typography>}></FormControlLabel>
                                    <FormControlLabel value={'FROM-TO-DATE'} control={<Radio />} label={<Typography color={filterDate.selectedDateFormat === 'FROM-TO-DATE' ? 'primary' : 'black'} variant='body1'><Label id="BetweenDates" /></Typography>}></FormControlLabel>
                                </RadioGroup>
                                {filterDate.selectedDateFormat !== 'ANY-DATE' && <FormControl className='inputSection filterInputDates'>
                                    <div>
                                        <input className='inputs'
                                            max="9999-12-31"
                                            required id='from-date-input' value={filterDate.fromDate} onChange={(event) => { setFilterDate({ ...filterDate, fromDate: event.target.value }); }} type='date' htmlFor='from-date-label' ></input>
                                        <label id='from-date-label'><Label id="From" /></label>
                                    </div>
                                    <div>
                                        {filterDate.dateError && <Typography variant='body2' color='red'>{filterDate.dateErrorDescription}</Typography>}
                                        <input className='inputs'
                                            max="9999-12-31"
                                            required id='to-date-input' ref={inputRefForToDate} type='date' value={filterDate.toDate} onChange={(event) => { setFilterDate({ ...filterDate, toDate: event.target.value }); }} htmlFor='to-date-label'></input>
                                        <label id='to-date-label' ref={labelRefForToDate}><Label id="To" /></label>
                                    </div>

                                </FormControl>}
                                <FormControl className='submitSection'>
                                    <Button variant='contained' className='resetBtn' color='primary' onClick={handleResetDate}><Label id="ResetFilter"/></Button>
                                    <Button variant='contained' className='submitBtn' color='primary' type='submit' disabled={filterDate.selectedDateFormat === 'FROM-TO-DATE' && !(filterDate.fromDate && filterDate.toDate) || filterDate.dateError} ><Label id="ApplyFilter" /></Button>
                                </FormControl>
                            </FormControl>
                        </Card>
                    </Popover>
                    <Button className='filterBtnPopver' id='search-member-id' onClick={setMemberFilter}>
                        {filterMember.labelName} {filterMember.openPopover ? <KeyboardArrowUp color='primary' /> : <KeyboardArrowDown color='primary' />}
                    </Button>
                    <Popover
                        open={filterMember.openPopover}
                        anchorEl={filterMember.anchorElement}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handleCloseMemberPopover}>
                        <Card className='popOverCard' component='form' onSubmit={handleFilterChanges}>
                            <Typography variant='body1'><Label id="PlanMembers" /></Typography>
                            {memberAccountError ? <>
                                <Card className='outlineCard error'>
                                    <Info className='outlineIcon error' color='primary' />
                                    <Typography variant='body1'>
                                        Something went wrong!
                                    </Typography>
                                    <Typography variant='subtitle1'>
                                        Plan members couldn’t be loaded right now. Please try again.
                                    </Typography>
                                    <CardActions className='outlineActArea'>
                                        <Button variant='contained' className='tryAgain' id='try-again-member-btn'>Try Again</Button>
                                    </CardActions>
                                </Card>
                            </> : <>
                                <FormControl>

                                    <RadioGroup onChange={setMemberHeader} value={filterMember.selectedMemberHeader}>
                                        {memberList && memberList[0]?.firstName && memberList.map((member, index) => {
                                            const memberAccountHeader = getMemberHeader(member);
                                            return <FormControlLabel key={index} value={memberAccountHeader} control={<Radio />}  label={<Typography color='primary' variant='body1'>{camelCaseString(member?.firstName) + ' ' + camelCaseString(member?.lastName)}</Typography>}></FormControlLabel>
                                        
                                        })}
                                    </RadioGroup>

                                </FormControl>
                                <Card className='outlineCard'>
                                    <Info className='outlineIcon' color='primary' />
                                    <Typography variant='body1'>
                                        <Label id="cantViewOtherAdultDependentClaims" />
                                    </Typography>
                                </Card>
                                <FormControl className='submitSection'>
                                    <Button variant='contained' className='resetBtn' color='primary' onClick={handleResetMemberFilter}><Label id="ResetFilter"/></Button>
                                    <Button variant='contained' className='submitBtn' color='primary' type='submit' disabled={!isMemberSelected}><Label id="ApplyFilter" /></Button>
                                </FormControl> </>}

                        </Card>
                    </Popover>
                </Container>

                <Container className='filtersRightSection'>
                    <Typography variant='h6' className='claimsSortHeader'><Label id="SortBy" />:</Typography>
                    <Container className='filters' onClick={handleSortFilter}>

                        <Typography variant='body1' className='claimsSortSubHeader'>{<Label id={sortFilter.labelName}/>}</Typography>
                        {sortFilter.labelName === 'Mostrecent' ? <ArrowDownward color='primary' style={{ fontSize: '24px' }} id='sort-button-filter' /> : <ArrowUpward color='primary' style={{ fontSize: '24px' }} id='sort-button-filter' onClick={handleSortFilter} />}
                    </Container>
                    

                </Container>
            </Container>}
            <Container className='claimsCards'>{claimsList && claimsList.map((element, index) => {
                return <React.Fragment key={element.claimNumber}>
                    <Card className='claimCard' onClick={() => { navigateToClaim(element.claimNumber, getMemberHeaderFromClaim(element)); }} >
                        <Card className='claimTop'>
                            <Typography variant='body1'>{getDateObj(element?.serviceDateFrom)?.displayDate}</Typography>
                            <Typography variant='body1'>Claim#   {element?.claimNumber}</Typography>
                            <Card className='claimDocName'>
                                <Typography variant='h6' color='primary'>{element?.providerName}</Typography>
                                <KeyboardArrowRightIcon className='claimNavigateIcon' color='secondary' id='claim-naviage'></KeyboardArrowRightIcon>
                            </Card>
                            <Typography variant='h6' color='defualt'>{element?.firstName + ' ' + element?.lastName}</Typography>
                        </Card>
                        <Card className='claimBottom'>
                            <Typography variant='h6'><Label id="YouMayOwe" /></Typography>
                            <Typography variant='h6'>${claimsYouOweList[index]}</Typography>
                        </Card>
                    </Card>
                </React.Fragment>;
            })} {paginationEnd && claimsList.length !== 0 && <Typography variant='h6'>
                <Label id='noClaimsToDisplay'/></Typography>}
                {claimsList && claimsList.length === 0 && <Typography variant='h6'><Label id="noClaims"/></Typography>}

                {claimsList && claimsList.length !== 0 && <Card className='paginationSection'>
                    <Pagination page={pageNumber} count={Math.ceil(totalElements / pageSize)} onChange={onPageChange} />
                </Card>}
                <Box mt={2} textAlign="left" className="claimsDisclaimerBox">
                    <Label id="claimsDisclaimer" />
                </Box>
            </Container>
            
        </Box>
    );
};
/* eslint enable */
export default ClaimsListSection;
